import React, { useEffect } from "react";
import { useDesign } from "../../context/contextDesign";
import { useThemeMode } from "../../context/contextTheme";
import { useAwsUrl } from "../../context/Dashboard/aws/contextUrl.js";
import Loader from "../../components/loaders/Loader-4";
import Loader2 from "../../components/loaders/Loader-8";
import ScanView from "./s3/ScanView.jsx";
import ScanCard from "./s3/ScanCard.jsx";

const AwsS3View = () => {
  const { theme } = useThemeMode();
  const { bHeightVal } = useDesign();
  const {
    loadWebData,
    webLoading,
    webResults,
    currentIndex,
    setCurrentIndex,
    urlScanLoading,
    urlDashboardView,
    setUrlDashboardView,
    setUrlHeader
  } = useAwsUrl();

  // Unified logic for data loading and header synchronization
  useEffect(() => {
    if (!urlScanLoading) {
      if (webResults?.length > 0) {
        // Keeps header sync with current view state
        setUrlHeader(urlDashboardView);
        loadWebData(currentIndex);
      } else {
        setUrlHeader(false);
        setUrlDashboardView(false);
      }
    }
  }, [webResults, currentIndex, urlScanLoading, urlDashboardView]);

  // Handler to return to existing reports view
  const handleReturnToDashboard = () => {
    setUrlDashboardView(true);
    setUrlHeader(true);
  };

  return (
    <div
      className="aws-s3-dashboard overflow-y-auto"
      style={{ height: bHeightVal }}
    >
      {webLoading ? (
        <Loader type="web_vul" cloud="aws" />
      ) : (
        <>
          {!urlDashboardView ? (
            <div className="p-1 col-12">
              {/* --- ACTION BUTTON: Redirection to existing S3 reports --- */}
              {webResults?.length > 0 && (
                <div className="d-flex justify-content-end px-4 mb-2">
                  <button
                    className="btn d-flex align-items-center gap-2 shadow-sm fw-bold"
                    onClick={handleReturnToDashboard}
                    style={{
                      backgroundColor: "#344266",
                      color: "white",
                      borderRadius: "10px",
                      fontSize: "0.85rem",
                      padding: "8px 20px"
                    }}
                  >
                    <i className="bi bi-cloud-check-fill"></i>
                    View S3 Report ({webResults.length})
                  </button>
                </div>
              )}

              <div className="mt-1" style={{ paddingRight: 10 }}>
                <ScanCard />
              </div>
            </div>
          ) : (
            <>
              {urlScanLoading ? (
                <div className="position-absolute top-50 start-50 translate-middle">
                  <div className="d-flex flex-column align-items-center text-center">
                    <Loader type="web_vul" />
                    <p className="mt-3 fw-bold text-muted small">Analyzing S3 Bucket Security...</p>
                  </div>
                </div>
              ) : (
                <div className="d-flex flex-row" style={{ paddingRight: 10 }}>
                  {/* SIDEBAR SELECTOR (Native Style) */}
                  <div className="d-flex flex-column mt-2" style={{ width: 76 }}>
                    {webResults.length > 0 &&
                      webResults.map((result, index) => (
                        <div
                          key={result.scan_uuid}
                          className="rounded-2 px-2 py-1 mb-2 fs-6 fw-semibold w-100 d-flex align-items-center justify-content-center"
                          onClick={() => setCurrentIndex(index)}
                          style={{
                            color: "white",
                            backgroundColor:
                              currentIndex === index
                                ? theme.labelTextDanger
                                : theme.secondary,
                            height: 34,
                            cursor: "pointer",
                            transition: "all 0.2s ease"
                          }}
                        >
                          S{index + 1}
                        </div>
                      ))}
                  </div>
                  <ScanView />
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default AwsS3View;